import React, { useState, useEffect } from "react";

//Importar íconos de Material UI.
import { Group, Construction } from '@mui/icons-material/';
import useNewRutaVisitada from "../hooks/useNewRootVisited";

const Users = ({ ruta, onChangeRuta }) => {
  useNewRutaVisitada(ruta, onChangeRuta);

  return (
    <div className="container-unselectedChat page">

      {/*--------Contenedor con el icono de Chat animado---------- */}
      <div className="content-mask-unselectedChat__icon" >
        {/*--------Icono de Chat en el color de la paleta-------------- */}
        <Group sx={{ fontSize: "200px", color: " var(--color-by-company)" }} />
      </div>
      <div className="content-mask-unselectedChat__icon--grey">
        {/*--------Icono de Chat en gris------------------------ */}
        <Group sx={{ fontSize: "200px" }} />
      </div>

      {/*------------Contenedor con el texto de seleccionar un chat */}
      <div className="content-unselectedChat--text">
        <span style={{ display: "flex", alignItems: "center" }}>
          <Construction sx={{ fontSize: "30px", marginRight: "10px" }} />
          Área en desarrollo</span>
      </div>

      {/*------------Contenedor con el logo de LPChat */}
      <div className="content-navigation__logo unselectedchat">
        {/* 
        <span className="logo-title-LP">LP</span>
        <span className="logo-title-CHAT">Chat</span> */}
        {/* <img src={logoLPChat} className="logo-small" alt="LPChat"></img> */}
      </div>
    </div>

  );


};

export default Users;